import { render, staticRenderFns } from "./ModalJustificativaRestricoes.vue?vue&type=template&id=2148bf3e&lang=pug"
import script from "./ModalJustificativaRestricoes.vue?vue&type=script&lang=js"
export * from "./ModalJustificativaRestricoes.vue?vue&type=script&lang=js"
import style0 from "./ModalJustificativaRestricoes.vue?vue&type=style&index=0&id=2148bf3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports